<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <vfooter v-if="hasFooter"></vfooter>

    <command></command>
  </div>
</template>

<script>
import vfooter from "@/components/vfooter"; //底部导航
import command from "@/components/command"; // 口令识别和转链
export default {
  components: {
    vfooter,
    command,
  },
  created() {
    let platform = 1;
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      platform = 2; // 手机
    } else {
      platform = 1; // 电脑端
    }
    this.$store.dispatch("setPlatform", platform);
    const deposit = this.getCookie("deposit");
    const rate = this.getCookie("rate");
    const agent = this.getCookie("agent");
    if (deposit && rate && agent) {
      const data = {
        deposit,
        rate,
        agent,
      };
      this.$store.dispatch("setConfig", data);
    } else {
      this.Post({}, "/main/config", res => {
        if (res.states == 1) {
          this.setCookie("deposit", res.data.deposit, 0.1);
          this.setCookie("rate", res.data.rate, 0.1);
          this.setCookie("agent", res.data.agent, 0.1);
          this.$store.dispatch("setConfig", res.data);
        }
      });
    }
  },
  computed: {
    hasFooter() {
      return ["/user", "/", "/jd", "/pdd"].includes(this.$route.path);
    }
  },
  methods: {}
};
</script>

<style lang="less" rel="stylesheet/less">
@import './assets/less/base.less';
</style>



// WEBPACK FOOTER //
// src/App.vue